//import "@/Font/MonsterFont";
//import "@fortawesome/fontawesome-svg-core/styles.css";
import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/tab";
import "lazysizes/plugins/print/ls.print";
import "lazysizes/plugins/respimg/ls.respimg";
import "lazysizes";

export class SiteBase
{
	public Initialize(): void
	{
		console.log("hello from SiteBase.");

		//	this.InitializeScriptErrorLogging();
	}

	private InitializeScriptErrorLogging()
	{
		//	TrackJS.install({
		//		token: "e80f94dada7040eb8fae21ddc6095ed2"
		//		// for more configuration options, see https://docs.trackjs.com
		//	});
	}
}